import React from 'react';
import displayConfig from '../data/galleryDisplayConfig.json';

const sizes = '(max-width: 374px) calc(100vw - 34px), (max-width: 767px) calc(100vw - 42px), (max-width: 1023px) calc((100vw - 84px) / 2), (max-width: 1199px) calc((100vw - 126px) / 3), (max-width: 1391px) calc((100vw - 172px) / 3), 407px';

export const GalleryPhoto = ({ image, category, index }) => {
  const directory = image.generated ? 'solutions-generated-gallery' : 'solutions-gallery';
  const prefix = `/images/${directory}/${category}-${index + 1}`;
  const widths = image.generated ? displayConfig.generatedWidths : displayConfig.widths;
  const srcSet = layout => widths.map(width => `${prefix}-${layout}-${width}.webp ${width}w`).join(', ');
  const position = displayConfig.photos[category].positions[index];
  return (
    <picture className="gallery-photo-frame">
      <source media="(max-width: 767px)" srcSet={srcSet('mobile')} sizes={sizes} />
      <source srcSet={srcSet('desktop')} sizes={sizes} />
      <img className="gallery-photo" src={`${prefix}-desktop-960.webp`} alt={image.alt}
        loading="lazy" decoding="async" draggable={false} width={image.generated ? 1264 : 1920} height={image.generated ? 815 : 1239}
        style={{ objectPosition: `${position[0] * 100}% ${position[1] * 100}%` }}
        data-source-image={image.src} data-testid={`gallery-image-${category}-${index + 1}`} />
    </picture>
  );
};